export const supplierOrdersPageData = [
    { title: "Get", status: "MISSING", type: "add", api: "apiGetSupplierOrderV2" },
    { title: "Create", status: "MISSING", type: "add", api: "apiCreateSupplierOrderV2" }
];

export const customerOrdersPageCardData = [
    { title: "Check", status: "MISSING", type: "add", api: "apiCheckShopperOrderV2" },
    { title: "Create Order", status: "MISSING", type: "add", api: "apiCreateShopperOrderV2" },
    { title: "Create Sale", status: "MISSING", type: "add", api: "apiCreateShopperSaleV2" },
    { title: "Webhook", status: "MISSING", type: "add", api: "webhookOnPosShopperOrderUpdatedV2" }
];

export const pricesPageCardData = [
    { title: "Get", status: "MISSING", type: "add", api: "apiGetPricesV2" },
    { title: "Webhook", status: "MISSING", type: "add", api: "webhookOnPosPriceUpdatedV2" }
];

export const stockPageCardData = [
    { title: "Get", status: "MISSING", type: "add", api: "apiGetStockV2" },
    { title: "Webhook", status: "MISSING", type: "add", api: "webhookOnPosStockUpdatedV2" }
];

export const productsPageCardData = [
    { title: "Get", status: "MISSING", type: "add", api: "apiGetProductsV2" },
    { title: "Check", status: "MISSING", type: "add", api: "apiCheckProductV2" },
    { title: "Create", status: "MISSING", type: "add", api: "apiCreateProductV2" },
    { title: "Update", status: "MISSING", type: "add", api: "apiUpdateProductV2" },
    { title: "Webhook", status: "MISSING", type: "add", api: "webhookOnMasterDataServerProductUpdateV2" }
];

export const storesPageCardData = [{ title: "Validate", status: "MISSING", type: "add", api: "apiValidateStoreV2" }];

export const posPageCardData = [
    { title: "Setup", status: "MISSING", type: "add", api: "apiSetupV2" },
    { title: "Undo Setup", status: "MISSING", type: "add", api: "apiUndoSetupV2" }
];
